import bike1 from "./IMG_0159.webp";
import bike2 from "./IMG_0172.webp";
import bike3 from "./IMG_0186.webp";
import bike4 from "./IMG_0236.webp";
import bike5 from "./IMG_0249.webp";
import bike6 from "./IMG_0248.webp";
import bike7 from "./20240811_091547.webp";
import bike8 from "./20240811_091537.webp";
import bike9 from "./rowery.webp";
import bike10 from "./IMG_0177.webp";
import bike11 from "./IMG_0232.webp";
import bike12 from "./IMG_0252.webp";

export const bikesImages = [
    { src: bike1, altKey: "1" },
    { src: bike2, altKey: "2" },
    { src: bike3, altKey: "3" },
    { src: bike4, altKey: "4" },
    { src: bike5, altKey: "5" },
    { src: bike6, altKey: "6" },
    { src: bike7, altKey: "7" },
    { src: bike8, altKey: "8" },
    { src: bike9, altKey: "9" },
    { src: bike10, altKey: "10" },
    { src: bike11, altKey: "11" },
    { src: bike12, altKey: "12" }
]; 